import { Area } from "../../../../_models/area";
import { Floor } from "../../../../_models/floor";
import { Room } from "../../../../_models/room";
import { Unit } from "../../../../_models/unit";

export class SelectedRoom {
  room: Room;
  unitId: number;
  unitName: string;
}

export class SelectedArea {
  area: Area;
  sectionId: number;
  sectionName: string;
  floorId: number;
  floorName: string;
  floorEndDate: string;
  unitId: number;
  unitName: string;
  unitEndDate: string;
  roomId: number;
  roomName: string;
  roomEndDate: string;
  type = 'AREA';
  areaLink: string
}
